const seo = {
  slug: 'f/seo',
  getPageRedirect: () => `${seo.slug}/page/redirect`,
  getPageSettings: () => `${seo.slug}/page/settings`
}

export default seo
